import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import MatrixHeading from "./MatrixHeading";
import "./Board.css";
import TiltedCard from "./TiltedCard";

const board2026 = [
  {
    name: "SHASHANK SINGH",
    position: "CHAIRPERSON",
    image: "board/2026/shashank.webp",
    instagram: "https://www.instagram.com/shashankkkkkk._",
    linkedin: "https://www.linkedin.com/in/shashank-singh-995a4727b/",
    github: "X"
  },
  {
    name: "KHWAISH AGARWALA",
    position: "VICE-CHAIRPERSON",
    image: "board/2026/khwaish.webp",
    instagram: "https://www.instagram.com/khwaish_1614",
    linkedin: "https://www.linkedin.com/in/khwaish-agarwala-94701028b",
    github: "https://github.com/KhwaishAg"
  },
  {
    name: "LAKSHYA GUPTA",
    position: "SECRETARY",
    image: "board/2026/lakshya.webp",
    instagram: "https://www.instagram.com/2005_lakshya",
    linkedin: "https://www.linkedin.com/in/lakshya-gupta2005",
    github: "https://github.com/2005lakshya"
  },
  {
    name: "SHRISHTI BATRA",
    position: "CO-SECRETARY",
    image: "board/2026/shrishti.webp",
    instagram: "https://www.instagram.com/shrishtii_._",
    linkedin: "https://www.linkedin.com/in/shrishti-batra-6b166628b?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
    github: "X"
  },

  {
    name: "BHAVYA KHATRI",
    position: "TECHNICAL HEAD",
    image: "board/2026/bhavya.webp",
    instagram: "https://www.instagram.com/bhavya.khatri678",
    linkedin: " https://www.linkedin.com/in/bhavya-khatri-4a580a323",
    github: "https://github.com/bhavya-khatri-59"
  },
  {
    name: "AASTHA NARAIN",
    position: "EVENTS HEAD",
    image: "board/2026/aastha.webp",
    instagram: "https://www.instagram.com/aastha_narain",
    linkedin: "https://www.linkedin.com/in/aastha-narain-b88ab328a/",
    github: "https://github.com/A-Narain"
  },
  {
    name: "SREENIVASA ANNAMANENI",
    position: "DESIGN HEAD",
    image: "board/2026/sreenivasa.webp",
    instagram: "https://www.instagram.com/sreenivasa25_2",
    linkedin: " https://in.linkedin.com/in/sreenivasa-annamaneni-10318b293",
    github: "X"
  },

  {
    name: "RUDRANSH RISCHIE",
    position: "FINANCE HEAD",
    image: "board/2026/rudransh.webp",
    instagram: "X",
    linkedin: "X",
    github: "X"
  },
  {
    name: "SAVAR GAMBHIR",
    position: "PUBLICITY HEAD",
    image: "board/2026/savar.webp",
    instagram: "https://www.instagram.com/savar09_xd",
    linkedin: "https://www.linkedin.com/in/savar-gambhir-027ab628a",
    github: "X"
  },
  {
    name: "HARSHIT KOLLA",
    position: "OUTREACH HEAD",
    image: "board/2026/harshit.webp",
    instagram: "X",
    linkedin: "https://www.linkedin.com/in/harshit-kolla-50914a288",
    github: "X"
  }
];

const board2025 = [
  {
    name: "TARUSH AGARWAL",
    position: "CHAIRPERSON",
    image: "board/2025/Tarush.webp",
    instagram: "https://www.instagram.com/tar10000/?hl=en",
    linkedin: "https://www.linkedin.com/in/tarush10000/"
  },
  {
    name: "HARDIK BANSAL",
    position: "VICE-CHAIRPERSON",
    image: "board/2025/bansal.webp",
    instagram: "https://www.instagram.com/hardik_.bansal/?hl=en",
    linkedin: "https://www.linkedin.com/in/hardikbansal2064/"
  },
  {
    name: "ARADHAY HARSHIT",
    position: "SECRETARY",
    image: "board/2025/Aradhay.webp",
    instagram: "https://www.instagram.com/anshul110904/?hl=en",
    linkedin: "https://www.linkedin.com/in/aradhay-harshit-44211b26a/"
  },
  {
    name: "YASHITA BERRY",
    position: "CO-SECRETARY",
    image: "board/2025/Yashita.webp",
    instagram: "https://www.instagram.com/yashita_berry/?hl=en",
    linkedin: "https://www.linkedin.com/in/yashita-berry-695578277/"
  },
  {
    name: "YASHVI GOYAL",
    position: "MANAGEMENT HEAD",
    image: "board/2025/Yashvi.webp",
    instagram: "https://www.instagram.com/yashvi_goyal04/?hl=en",
    linkedin: "https://www.linkedin.com/in/yashvi-goyal-35a248281/"
  },
  {
    name: "HARDIK SINGLA",
    position: "TECHNICAL HEAD",
    image: "board/2025/Singla.webp",
    instagram: "https://www.instagram.com/hardik._.singla/?hl=en",
    linkedin: "https://www.linkedin.com/in/hardik-singla-163112232/"
  },
  {
    name: "RHYTHM GUPTA",
    position: "EVENTS HEAD",
    image: "board/2025/Rhythm.webp",
    instagram: "https://www.instagram.com/_rhythm.14_/?hl=en",
    linkedin: "https://www.linkedin.com/in/rhythm-gupta-520077253/"
  },
  {
    name: "JIYA PALIWAL",
    position: "DESIGN HEAD",
    image: "board/2025/Jiya.webp",
    instagram: "https://www.instagram.com/jiya_paliwal_/?hl=en",
    linkedin: "https://www.linkedin.com/in/jiya-paliwal3414/"
  },
  {
    name: "KARTIK KAR",
    position: "PROJECTS HEAD",
    image: "board/2025/Kartik.webp",
    instagram: "https://www.instagram.com/kartik_kar_19/?hl=en",
    linkedin: "https://www.linkedin.com/in/kartik-kar/"
  },
  {
    name: "MAITREYA CHAVAN",
    position: "FINANCE HEAD",
    image: "board/2025/Maitreya.webp",
    instagram: "https://www.instagram.com/_maitreyaaaa_/?hl=en",
    linkedin: "https://www.linkedin.com/in/maitreya-chavan-65a638250/"
  },
  {
    name: "BHAVYA SHUKLA",
    position: "PUBLICITY HEAD",
    image: "board/2025/Bhavya.webp",
    instagram: "https://www.instagram.com/bhavyaaa._1/?hl=en",
    linkedin: "https://www.linkedin.com/in/bhavya-shukla-b96a5a288/"
  },
  {
    name: "HARSHITHA K.",
    position: "EDITORIAL HEAD",
    image: "board/2025/Harshita.webp",
    instagram: "https://www.instagram.com/har_shitha__kss_/?hl=en",
    linkedin: "https://www.linkedin.com/in/harshitha-kommareddy-b087a4274/"
  },
  {
    name: "DIVYAM SINGHVI",
    position: "R & D HEAD",
    image: "board/2025/Divyam.webp",
    instagram: "https://www.instagram.com/divyam_singhvi/?hl=en",
    linkedin: "https://www.linkedin.com/in/divyam-singhvi-950257261/"
  }
];

const Board = () => {
  const [activeTab, setActiveTab] = useState("2026");
  const [activeYearBoard, setActiveYearBoard] = useState("Board2026");
  const [selectedMember, setSelectedMember] = useState(board2026[0]);

  // MatrixHeading reveal — fires when the section enters the viewport
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return undefined;
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.25 },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  // Slideshow auto-advance — cycles through the active year every 3.5s
  useEffect(() => {
    const activeBoard = activeYearBoard === "Board2026" ? board2026 : board2025;
    const intervalId = setInterval(() => {
      setSelectedMember((prev) => {
        if (!prev) return activeBoard[0];
        const currentIndex = activeBoard.findIndex((m) => m.name === prev.name);
        if (currentIndex === -1) return activeBoard[0];
        const nextIndex = (currentIndex + 1) % activeBoard.length;
        return activeBoard[nextIndex];
      });
    }, 3500);
    return () => clearInterval(intervalId);
  }, [activeYearBoard]);

  const handleTabClick = (year) => {
    setActiveTab(year);
    setActiveYearBoard(year === "2026" ? "Board2026" : "Board2025");
    setSelectedMember(year === "2026" ? board2026[0] : board2025[0]);
  };

  // Animate the .tabs selector pill
  useEffect(() => {
    const tabs = document.querySelector("#Board .tabs");
    const selector = document.querySelector("#Board .selector");
    if (!tabs || !selector) return undefined;
    const activeItem = tabs.querySelector(".active");
    if (activeItem) {
      selector.style.left = `${activeItem.offsetLeft}px`;
      selector.style.width = `${activeItem.offsetWidth}px`;
    }
    const handleTabSelector = (event) => {
      const item = event.target;
      if (item.tagName === "A") {
        selector.style.left = `${item.offsetLeft}px`;
        selector.style.width = `${item.offsetWidth}px`;
      }
    };
    tabs.addEventListener("click", handleTabSelector);
    return () => tabs.removeEventListener("click", handleTabSelector);
  }, [activeTab]);

  /* Honeycomb (right column) — only the grid of clickable hexagons.
     The selected member's detail card lives on the LEFT instead. */
  const renderHoneycomb = (members) => {
    const rows = [];
    let i = 0;
    let isThree = true;
    while (i < members.length) {
      const chunkSize = isThree ? 3 : 4;
      const rowMembers = members.slice(i, i + chunkSize);
      while (rowMembers.length < chunkSize) rowMembers.push(null);
      rows.push(rowMembers);
      i += chunkSize;
      isThree = !isThree;
    }

    return (
      <div className="brd-honeycomb">
        {rows.map((row, rowIndex) => (
          <div className="brd-honeycomb-row" key={rowIndex}>
            {row.map((member, colIndex) => {
              if (!member) {
                return (
                  <div
                    key={`empty-${rowIndex}-${colIndex}`}
                    className="brd-hex-wrapper"
                    style={{ visibility: "hidden" }}
                  />
                );
              }
              const isActive = selectedMember?.name === member.name;
              return (
                <div
                  key={`${member.name}-${colIndex}`}
                  className={`brd-hex-wrapper${isActive ? " is-selected" : ""}`}
                  onClick={() => setSelectedMember(member)}
                >
                  <div className="brd-hex-shadow">
                    <div className="brd-hex-cell">
                      <img
                        src={member.image}
                        alt={member.name}
                        className="brd-hex-image"
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    );
  };

  return (
    <section id="Board" ref={sectionRef}>
      <div className="brd-split">
        {/* LEFT — title block + active member info (mirrors About Us) */}
        <div className="brd-left">

          <h2 className="brd-main-heading">
            <MatrixHeading text="Board" active={isVisible} />
          </h2>

          <p className="brd-tagline">
            <span className="brd-tagline-row">LEADERS</span>
            <span className="brd-tagline-row">INNOVATORS</span>
          </p>

          <div className="brd-heading-line" />

          {/* Selected member detail — fades in / out on selection */}
          <div className="brd-member-wrap">
            <AnimatePresence mode="wait">
              {selectedMember && (
                <motion.div
                  key={selectedMember.name}
                  initial={{ opacity: 0, y: 14 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.3, ease: "easeOut" }}
                  className="brd-member-card"
                >
                  <div className="brd-member-photo">
                    <TiltedCard
                      imageSrc={selectedMember.image}
                      altText={`${selectedMember.name}, IEEE TEMS VIT`}
                      containerHeight="100%"
                      containerWidth="100%"
                      imageHeight="100%"
                      imageWidth="100%"
                      rotateAmplitude={12}
                      scaleOnHover={1.05}
                      showMobileWarning={false}
                      showTooltip={false}
                      displayOverlayContent={false}
                    />
                  </div>
                  <div className="brd-member-info">
                    <h3 className="brd-member-name">{selectedMember.name}</h3>
                    <p className="brd-member-role">{selectedMember.position}</p>
                    <div className="brd-member-socials">
                      {selectedMember.instagram && selectedMember.instagram !== "X" && (
                        <a
                          href={selectedMember.instagram}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="Instagram"
                        >
                          <i className="fa-brands fa-instagram"></i>
                        </a>
                      )}
                      {selectedMember.linkedin && selectedMember.linkedin !== "X" && (
                        <a
                          href={selectedMember.linkedin}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="LinkedIn"
                        >
                          <i className="fa-brands fa-linkedin"></i>
                        </a>
                      )}
                      {selectedMember.github && selectedMember.github !== "X" && (
                        <a
                          href={selectedMember.github}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="GitHub"
                        >
                          <i className="fa-brands fa-github"></i>
                        </a>
                      )}
                    </div>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          <p className="brd-mission-text">
            Meet the team driving IEEE TEMS VIT forward.
          </p>
        </div>

        {/* RIGHT — year tabs + honeycomb of members (bigger hexes) */}
        <div className="brd-right">
          <div className="wrapper" id="content-desktop">
            <nav className="tabs">
              <div className="selector"></div>
              <a
                href="#Board"
                id="Board-switch-2026"
                className={
                  activeTab === "2026"
                    ? "active no-border-on-link"
                    : "no-border-on-link"
                }
                onClick={() => handleTabClick("2026")}
              >
                2026
              </a>
              <a
                href="#Board"
                id="Board-switch-2025"
                className={
                  activeTab === "2025"
                    ? "active no-border-on-link"
                    : "no-border-on-link"
                }
                onClick={() => handleTabClick("2025")}
              >
                2025
              </a>
            </nav>
          </div>

          <div
            className={`Board2026 board-content ${
              activeYearBoard === "Board2026" ? "active-year-board highlight" : ""
            }`}
            id="Board2026"
          >
            {renderHoneycomb(board2026)}
          </div>

          <div
            className={`Board2025 board-content ${
              activeYearBoard === "Board2025" ? "active-year-board highlight" : ""
            }`}
            id="Board2025"
          >
            {renderHoneycomb(board2025)}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Board;
